import React from 'react'
import HeaderNew from '../HeaderNew'
import '../Common/Common.css'
import Footer from '../Common/Footer'

class AddEditStoreLocation extends React.Component {
    constructor() {
        super()
        this.state = {
            locationCode: '',
            locationName: '',
            locationCodeError: false,
            locationNameError: false,
            storeID: '',
            store:null,
            // action: '',
            key: '',
            saving: false
        }
        this.onSaveStoreLocation = this.onSaveStoreLocation.bind(this)
        this.formControls = this.formControls.bind(this)
    }

    componentDidMount() {
        this.setState({
            storeID: this.props.store.key,
            store:this.props.store
            // action: this.props.action
        })
        // console.log('storeID', this.props.storeID)
        if (this.props.storeLocation) {
            this.setState({
                key: this.props.storeLocation.key,
                locationCode: this.props.storeLocation.LocationCode,
                locationName: this.props.storeLocation.LocationName
            })
        }
    }

    onSaveStoreLocation() {
        this.setState({ saving: true })
        //check if location code and location name is entered 
        let locationCodeError = false
        let locationNameError = false
        if (this.state.locationCode.trim() === "") { locationCodeError = true }
        if (this.state.locationName.trim() === "") { locationNameError = true }
        this.setState({
            locationCodeError: locationCodeError,
            locationNameError: locationNameError, saving: false
        })
        if (locationCodeError || locationNameError) { return }
        //check location code is unique
        let location = {
            LocationCode: this.state.locationCode,
            LocationName: this.state.locationName,
            StoreID: this.state.storeID,
            RegistrationID: this.props.user.user.RegistrationID,
            IsDelete: false
        }

        if (this.state.key === '') {
            this.props.addStoreLocation(location).then(() => {
                this.props.getToastr("Store Location Saved Successfully")
                this.setState({ saving: false })
                this.props.onSave()
            })
        }
        else{
            this.props.updateStoreLocation(location, this.state.key).then(() => {
                this.props.getToastr("Store Location Saved Successfully")
                this.setState({ saving: false })
                this.props.onSave()
            })
        }
    }

    formControls()
    {
        return <React.Fragment>
            
            <div className={this.state.locationCodeError ? "form-group has-error" : "form-group "} >
                    <label>Location Code</label>
                    <input type="text" className="form-control"
                        onChange={(evt) => this.setState({ locationCode: evt.target.value, locationCodeError: "" })}
                        value={this.state.locationCode} />
                    {this.state.locationCodeError && <span className="help-block">Please provide location code</span>}
                </div>
                <div className={this.state.locationNameError ? "form-group has-error" : "form-group "} >
                    <label>Location Name</label>
                    <input type="text" className="form-control"
                        onChange={(evt) => this.setState({ locationName: evt.target.value, locationNameError: "" })}
                        value={this.state.locationName} />
                    {this.state.locationNameError && <span className="help-block">Please provide location name</span>}
                </div>
        </React.Fragment>
    }
    render() {
        return <div>

        {this.props.isMobileApp() &&  <React.Fragment>   
            <HeaderNew {...this.props}
                back={true}
                title= { this.state.key === "" ? "Add New Location" : "Edit Location" }
                onBackClick={() => { this.props.onClose()}}
            />
            <div className="header-new-background"/>
            <div className="content-wrapper">
                <div className="container">
                    
                    <br/>
                    
                    <div className="form-group">
                        <label>Store Code</label>
                        <input type="text" className="form-control"
                            value={this.state.store ? this.state.store.StoreCode : ''}
                        />
                    </div>

                    <div className="form-group">
                        <label>Store Name</label>
                        <input type="text" className="form-control"
                                value={this.state.store ? this.state.store.StoreName: ''}
                            />
                    </div>
                    
                    {this.formControls()}
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <Footer onClick={()=> this.onSaveStoreLocation()} />
                </div>
            </div>
        </React.Fragment>}

        {!this.props.isMobileApp() &&  <React.Fragment>  
            {this.state.key === "" && <h3 style={{ marginTop: "0px" }}>Add New Location</h3>}
            {this.state.key !== "" && <h3 style={{ marginTop: "0px" }}>Edit Location</h3>}
            <div className="box-body">
                {this.formControls()}
            </div>
            <div className="box-footer">
                <button type="submit" className="btn btn-flat btn-md btn-flat btn-default" onClick={this.props.onClose} >Cancel</button>
                <button type="submit" className="btn btn-flat btn-md btn-flat btn-success pull-right" onClick={this.onSaveStoreLocation} disabled={this.state.saving}>Save</button>
            </div>
        </React.Fragment>}

        </div>
        
        // <section className="content" >
        //     <section className="content-header">
        //         <h1> Add New Location</h1>
        //     </section>
        //     <div className="box-body">
                
        //     </div>
        //     <div className="box-footer">
        //         <button type="submit" className="btn btn-md btn-flat btn-default" onClick={this.props.onClose} >Cancel</button>
        //         <button type="submit" className="btn btn-flat btn-md btn-flat btn-success pull-right" onClick={this.onSaveStoreLocation} disabled={this.state.saving}>Save</button>
        //     </div>
        // </section>
    }
}

export default AddEditStoreLocation